import ResetPassword from '@/features/auth/reset-password'
import { createFileRoute } from '@tanstack/react-router'

type ResetPasswordSearchParams = {
  email: string
}



export const Route = createFileRoute('/(auth)/reset-password')({
  component: ResetPassword,
  validateSearch: ({ search }) => ({} as ResetPasswordSearchParams)
})
